<template>
    <header class="header-menu" v-bind:style="{ 'margin-bottom': computedMB }">
        <!-- Menú principal -->
        <v-row class="menu">
            <v-col class="logo" cols="2">
                <img class="logo_header" style="width: 60%; height: auto" src="./icono-web.png"
                    @click="navigate($baseWebUrl + '/inicio')" />
            </v-col>
            <v-col class="navCol" cols="10">
                <v-row v-if="$mq !== 'mobile'">
                    <v-col class="menuElem" @click="openClose('desc')">
                        <h1 class="mainNav" style="padding-top: 15px">Descubre</h1>
                        <svg viewBox="0 0 1030 638" width="10" v-if="!this.descSvg">
                            <path d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
                                fill="#000000"></path>
                        </svg>
                        <svg viewBox="0 0 1030 638" width="10" transform="rotate(180)" v-if="this.descSvg">
                            <path d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
                                fill="#000000"></path>
                        </svg>
                    </v-col>
                    <v-col class="menuElem" @click="openClose('disf')">
                        <h1 class="mainNav" style="padding-top: 15px">Disfruta</h1>
                        <svg viewBox="0 0 1030 638" width="10" v-if="!this.disfSvg">
                            <path d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
                                fill="#000000"></path>
                        </svg>
                        <svg viewBox="0 0 1030 638" transform="rotate(180)" width="10" v-if="this.disfSvg">
                            <path d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
                                fill="#000000"></path>
                        </svg>
                    </v-col>
                    <v-col class="menuElem" @click="openClose('plan')">
                        <h1 class="mainNav" style="padding-top: 15px">Planifica</h1>
                        <svg viewBox="0 0 1030 638" width="10" v-if="!this.planSvg">
                            <path d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
                                fill="#000000"></path>
                        </svg>
                        <svg transform="rotate(180)" viewBox="0 0 1030 638" width="10" v-if="this.planSvg">
                            <path d="M1017 68L541 626q-11 12-26 12t-26-12L13 68Q-3 49 6 24.5T39 0h952q24 0 33 24.5t-7 43.5z"
                                fill="#000000"></path>
                        </svg>
                    </v-col>
                    <v-col class="menuElem">
                        <router-link to="/tarjeta">
                            <h1 class="mainNav">OPENDATA</h1>
                        </router-link>
                    </v-col>

                    <v-col class="menuElem">
                        <router-link to="/turismo-accesible">
                            <h1 class="mainNav">TURISMO ACCESIBLE</h1>
                        </router-link>
                    </v-col>
                    <v-col>
                        <v-spacer></v-spacer>
                        <v-icon medium color="#000" @click="buscador()"> mdi-magnify </v-icon>
                        <v-spacer></v-spacer>
                    </v-col>
                </v-row>
            </v-col>
            <Dropdown class="subMenu" ref="desc" title="Descubre" :items="descubreItems" v-if="descubreItems.length > 0" />
            <Dropdown class="subMenu" ref="disf" title="Disfruta" :items="disfrutaItems" v-if="disfrutaItems.length > 0" />
            <DropdownPlanifica class="subMenu" ref="plan" title="Planifica" />
        </v-row>
        <!-- Popup Search -->
        <Search class="buscador" v-if="this.buscadorToolbar && $mq !== 'mobile'"></Search>

        <!-- <Search class="buscadorMovil" v-if="this.buscadorToolbar && $mq === 'mobile'"></Search> -->
    </header>
</template>
  
<script>
import Dropdown from "./DropdownMenu.vue";
import DropdownPlanifica from "./DropdownPlanifica.vue";
import MenuService from "../../services/MenuService";
import Search from "./Search.vue";

export default {
    name: "MenuCastropol",
    components: {
        Dropdown,
        DropdownPlanifica,
        Search,
    },
    computed: {
        computedMB: function () {
            return this.mbH;
        },
    },
    data() {
        return {
            mbH: "0",
            descubreItems: [],
            disfrutaItems: [],
            descSvg: false,
            disfSvg: false,
            planSvg: false,
            buscadorToolbar: false,
            counterDesc: 0,
            counterDisf: 0,
            mobileMenuOpen: false,
            drawer: null,
            // Ruta Inicio
            rutaInicio: "/inicio",
            // Rutas Descubre
            rutaLugares: "/lugares",
            rutaMapaInt: "/mapa",
            rutaNoticia: "/noticias",
            rutaPdi: "/pdi",
            rutaRutas: "/rutas",

            // Rutas Disfruta
            rutaCallejeros: "/callejeros",
            rutaCuriosidades: "/curiosidades",
            rutaDescargaInformacion: "/descarga",
            rutaEnlacesInteres: "/enlaces",
            rutaEventos: "/eventos",

            // Rutas Planifica
            rutaOficina: "/oficina",
            rutaMapaInt: "/mapa",
            rutaDormir: "/dormir",
            rutaComer: "/comer",
            rutaActividades: "/actividades",

            // Ruta Turismo Accesible
            turismoaccesible: "/turismo-accesible",

        };

    },
    async mounted() {
        await this.setMenu();
    },
    methods: {
        async setMenu() {
            await this.setDescubre();
            await this.setDisfruta();
        },
        async setDescubre() {
            var obj = await MenuService.getAllDescubre();
            var arr = obj.data.data;
            this.descubreItems = [];
            var js = {};
            var larr = arr.length;
            arr.forEach((item) => {
                if (item.attributes.optionalUrl == null || item.attributes.optionalUrl.trim() == "") {
                    js = {
                        title: item.attributes.texto,
                        link: "#",
                        submenu: item.attributes.submenu,
                    };
                } else {
                    js = {
                        title: item.attributes.texto,
                        link: item.attributes.optionalUrl,
                        submenu: [],
                    };
                }
                this.descubreItems.push(js);
            });

            this.counterDesc = larr;
        },
        async setDisfruta() {
            var obj = await MenuService.getAllDisfruta();
            var arr = obj.data.data;
            this.disfrutaItems = [];
            var js = {};
            var larr = arr.length;
            arr.forEach((item) => {
                if (item.attributes.optionalUrl == null || item.attributes.optionalUrl.trim() == "") {
                    js = {
                        title: item.attributes.texto,
                        link: "#",
                        submenu: item.attributes.submenu,
                    };
                } else {
                    js = {
                        title: item.attributes.texto,
                        link: item.attributes.optionalUrl,
                        submenu: [],
                    };
                }
                this.disfrutaItems.push(js);
            });
            this.counterDisf = larr;
        },
        navigate(url) {
            window.location.href = url;
        },
        modMargin(marg) {
            this.mbH = this.formatMargin(marg);
        },
        formatMargin(val) {
            return this.calc(val) + "%";
        },
        calc(val) {
            return 2 * val + 2 * val - (val * 95) / 100;
        },
        openClose: function (referencia) {
            switch (referencia) {
                case "desc":
                    this.$refs.desc.isOpen = !this.$refs.desc.isOpen;
                    this.$refs.disf.isOpen = false;
                    this.$refs.plan.isOpen = false;
                    this.$refs.desc.segundaColAbierta = false;
                    this.descSvg = !this.descSvg;
                    this.disfSvg = false;
                    this.planSvg = false;
                    this.buscadorToolbar = false;
                    if (this.counterDesc) this.mbH = this.formatMargin(this.counterDesc);
                    break;
                case "disf":
                    this.$refs.desc.isOpen = false;
                    this.$refs.disf.isOpen = !this.$refs.disf.isOpen;
                    this.$refs.plan.isOpen = false;
                    this.$refs.desc.segundaColAbierta = false;
                    this.descSvg = false;
                    this.disfSvg = !this.disfSvg;
                    this.planSvg = false;
                    this.buscadorToolbar = false;
                    if (this.counterDisf) this.mbH = this.formatMargin(this.counterDisf);
                    break;
                case "plan":
                    this.$refs.desc.isOpen = false;
                    this.$refs.disf.isOpen = false;
                    this.$refs.plan.isOpen = !this.$refs.plan.isOpen;
                    this.descSvg = false;
                    this.disfSvg = false;
                    this.planSvg = !this.planSvg;
                    this.buscadorToolbar = false;
                    this.mbH = "13.85em";
                    break;
                default:
                    this.$refs.desc.isOpen = false;
                    this.$refs.disf.isOpen = false;
                    this.$refs.plan.isOpen = false;
                    this.descSvg = false;
                    this.disfSvg = false;
                    this.planSvg = false;
                    this.mbH = "0em";
                    break;
            }

            this.$refs.desc.test = false;
            this.$refs.disf.test = false;
            this.$refs.plan.test = false;
            if (!this.$refs.desc.isOpen && !this.$refs.disf.isOpen && !this.$refs.plan.isOpen) this.mbH = "0em";
        },
        buscador() {
            this.buscadorToolbar = !this.buscadorToolbar;
            this.openClose();
        },
        // Nuevo método para controlar la apertura/cierre del menú móvil
        toggleMobileMenu() {
            this.mobileMenuOpen = !this.mobileMenuOpen;
        },
    },
};
</script>
  
<style scoped>
* {
    z-index: 99;
}
header {
    padding: 0;
    margin: 0;
}

.header-menu {
    z-index: 50;
}

h1 {
    font-family: "Amatic SC", cursive;
    font-size: 1.5em;
}

.menu {
    top: 50;
    height: 8em;
    background-color: white;
    margin: 0px;
}

.navCol {
    display: flex;
    justify-content: cenlefter;
    align-items: center;
}

.logo {
    width: 100%;
    height: 100%;
    justify-content: left;
}

.logo_header:hover {
    cursor: pointer;
}

div {
    display: flex;
    justify-content: center;
    align-items: center;
}

div .menu-item {
    position: sticky;
}

svg {
    padding-top: 1em;
    width: 10px;
    margin-left: 10px;
    z-index: 999;
    padding-bottom: 0.8em;
}

.subMenu {
    position: sticky;
    margin-top: 0.1em;
}

/* Estilos para el menú principal */
.menuElem {
    display: flex;
    align-content: center;
    align-items: center;
    justify-content: center;
}

.menuElem:hover {
    background-color: #d6deab;
    cursor: pointer;
}

.svgBot {
    margin-bottom: 2em;
}

.buscador {
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    border-left: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    float: right;
    width: fit-content;
    min-width: 30%;
    position: absolute;
    left: auto;
    right: 2em;
}

.buscadorMovil {
    border-right: 1px solid #000;
    border-bottom: 1px solid #000;
    border-left: 1px solid #000;
    display: flex;
    justify-content: center;
    align-items: center;
    float: right;
    width: fit-content;
    min-width: 30%;
    position: absolute;
    left: auto;
    right: 0;
}

@media screen and (max-width: 600px) {
    .menu {
        height: 15em;
    }

    .logo {
        height: auto;
        width: 100%;
        position: relative;
        padding: 20px;
    }

    img {
        width: 100%;
        height: 100%;
    }

    .subtituloImg {
        font-size: 0.2em;
    }
}

/* Estilos para el botón de hamburguesa y el menú móvil en pantallas pequeñas */
@media screen and (max-width: 600px) {
    .custom-item:hover {
        background-color: #d6e0a8;
    }

    .menu {
        display: none;
        /* Oculta el menú principal en pantallas pequeñas */
    }

    .mobile-menu-button {
        display: block;
        /* Muestra el botón de hamburguesa en pantallas pequeñas */
    }
}
</style>
  